<template>
  <div class="container">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/websites' }">概览</el-breadcrumb-item>
        <el-breadcrumb-item>解析管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <template>
      <el-row>
        <el-input v-model="dnspodKeywords" placeholder="请输入站点或域名关键字" clearable style="width: 300px; margin-right: 10px;"
          @clear="getDnspodList()"></el-input>
        <el-button type="primary" @click="dnspodPage = 1; getDnspodList()" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="addDomain" icon="el-icon-plus">添加</el-button>
      </el-row>
      <br>
      <el-table :data="dnspodList" border style="width: 100%" height="650" stripe v-loading="dnspodLoading">
        <el-table-column prop="name" label="域名" width="300" fixed>
          <template v-slot="scope">
            <el-link type="primary" @click="manage(scope.row)" title="点击进入管理">{{ scope.row.name }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="provider" label="服务平台" width="120"></el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template v-slot="scope">
            <div v-if="scope.row.dns_status === 'DNSERROR'">
              <el-popover placement="top" :key="`pop-${scope.row.id}`" popper-class="tiny-pop text-extra-small"
                trigger="hover" width="130">
                <div>请修改成以下解析</div>
                <div v-for="(ns, idx) in scope.row.ns" :key="idx">
                  {{ ns }}
                  <el-link :underline="false"><i class="el-icon-copy-document hover-icon"
                      @click="copy(ns)"></i></el-link>
                </div>
                <el-button type="primary" size="mini"
                  :icon="scope.row.loading ? 'el-icon-loading' : 'el-icon-warning-outline'"
                  @click="autoRepairNs(scope.row, scope.$index)">{{ scope.row.loading ? '正在验证' : '重新验证' }}</el-button>
                <i class="el-icon-question grey text-small" slot="reference"> NS未修正</i>
              </el-popover>
            </div>
            <div v-else>
              <!-- <el-popover placement="top" :key="`pop-${scope.row.id}`" popper-class="tiny-pop" trigger="hover"
                v-if="scope.row.status === 'ENABLE'" width="75">
                <el-button type="primary" size="mini"
                  :icon="scope.row.loading ? 'el-icon-loading' : 'el-icon-warning-outline'"
                  @click="autoRepairNs(scope.row, scope.$index)">{{ scope.row.loading ? '' : '暂停'
                  }}</el-button>
                <i class="el-icon-success green text-small" slot="reference"> 正常</i>
              </el-popover> -->
              <i class="el-icon-success green text-small" v-if="scope.row.status === 'ENABLE'"> 正常</i>
              <i class=" el-icon-video-pause grey text-small" v-if="scope.row.status === 'PAUSE'"> 暂停</i>
              <i class="el-icon-warning red text-small" v-if="scope.row.status === 'SPAM'"> 封禁</i>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="record_count" label="记录数" width="80"></el-table-column>
        <el-table-column prop="register_time" label="注册时间" width="200"></el-table-column>
        <el-table-column prop="expired_time" label="到期时间" width="200">
          <template v-slot="scope">
            <span :class="scope.row.expired_warning ? 'red' : ''">{{ scope.row.expired_time }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="auto_renew" label="自动续费" width="90">
          <template v-slot="scope">
            <el-switch v-model="scope.row.auto_renew" active-color="#13ce66" inactive-color="#ccc"
              @change="toggleDomainAutoRenew(scope.row, scope.$index)">
            </el-switch>
          </template>
        </el-table-column> -->
        <el-table-column prop="creator_name" label="创建人" width="100"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template v-slot="scope">
            <el-link type="primary" :underline="false" @click="manage(scope.row)" class="text-small">管理</el-link>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <el-link type="danger" :underline="false" @click="deleteDomain(scope.row)" class="text-small">移除托管</el-link>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <br>
    <div class="pagenation">
      <el-pagination background layout="total, sizes, prev, pager, next" :total="dnspodTotal"
        @size-change="changeDnspodSize" @current-change="currentDnspodChange" :page-sizes="[10, 20, 50, 100]"
        :page-size="dnspodSize">
      </el-pagination>
    </div>
    <el-dialog title="添加域名" :visible.sync="addDomainVisible" :close-on-click-modal="false">
      <el-form :model="addDomainForm" label-width="100px" :rules="addDomainRules" ref="addDomainForm"
        v-loading="addDomainLoading" element-loading-text="正在添加, 预计等待1分钟, 请稍候">
        <el-row>
          <el-col :span="20">
            <el-form-item label="域名" prop="domain">
              <el-input v-model="addDomainForm.domain" placeholder="输入域名, 不要带www"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDomainVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAddDomain">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Nav from '../../Global/Nav.vue'
export default {
  name: 'WebsitesDnspod',
  components: {
    Nav
  },
  data() {
    return {
      dnspodKeywords: '',
      dnspodList: [],
      dnspodLoading: true,
      dnspodTotal: 0,
      dnspodPage: 1,
      dnspodSize: 20,
      addDomainVisible: false,
      addDomainLoading: false,
      addDomainForm: {
        domain: ''
      },
      addDomainRules: {
        domain: [
          { required: true, message: '域名不能为空', trigger: 'commit' }
        ]
      }
    }
  },
  mounted() {
    this.getDnspodList();
  },
  methods: {
    copy(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    },
    addDomain() {
      this.addDomainVisible = true;
      this.addDomainLoading = false;
      this.addDomainForm = {
        domain: ''
      }
    },
    async confirmAddDomain() {
      await this.$refs.addDomainForm.validate(valid => {
        if (valid) {
          this.addDomainLoading = true;
          this.$axios.post(`/tencent/dnspod/create`, this.addDomainForm).then((response) => {
            if (response.data.code === 200) {
              setTimeout(() => {
                this.addDomainLoading = false;
                this.addDomainVisible = false;
                this.getDnspodList();
                this.$notify({
                  title: '提示',
                  message: "添加成功",
                  type: 'success'
                });
              }, 10000);
            }
          }).catch(() => {
            this.addDomainLoading = false;
          });
        }
      })
    },
    async getDnspodList() {
      this.dnspodLoading = true;
      await this.$axios.get(`/tencent/dnspod/list`, {
        params: {
          keywords: this.dnspodKeywords,
          page: this.dnspodPage,
          size: this.dnspodSize
        }
      }).then((response) => {
        this.dnspodLoading = false;
        if (response.data.code === 200) {
          this.dnspodList = response.data.data.data;
          this.dnspodTotal = response.data.data.total;
        }
      });
    },
    changeDnspodSize(val) {
      this.dnspodSize = val;
      this.getDnspodList();
    },
    currentDnspodChange(val) {
      this.dnspodPage = val;
      this.getDnspodList();
    },
    async autoRepairNs(row, index) {
      // 此处应执行刷新动作
      this.$set(this.dnspodList, index, {
        ...row,
        loading: true
      });
      await this.$axios.post(`/tencent/dnspod/sync_one`, {
        domain: row.name
      }).then((response) => {
        setTimeout(() => {
          this.$set(this.dnspodList, index, {
            ...row,
            loading: false
          });
          this.getDnspodList();
        }, 10000);
      })
    },
    manage(row) {
      this.$router.push({
        name: 'websites_dnspod_detail',
        params: {
          domain: row.name
        }
      });
    },
    async deleteDomain(row) {
      await this.$confirm("此操作将会同时删除所有解析记录, 此操作不可恢复, 确定吗?", '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dnspodLoading = true;
        this.$axios.post(`/tencent/dnspod/delete`, {
          domain: row.name
        }).then((response) => {
          this.dnspodLoading = false;
          this.getDnspodList();
          this.$notify({
            title: '提示',
            message: "操作成功",
            type: 'success'
          });
        }).catch();
      })
    }
  }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/Modules/Websites/Dnspod.vue